import { InputAdornment, MenuItem, Stack, TextField } from '@mui/material'
import { CloseIcon, SearchIcon } from 'components/Icons'
import { debounce, omit } from 'lodash'
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getCourseSubjects } from 'store/lookup'
import { search } from 'store/scheduling/course'

export default function SchedulingCoursesSearchBar() {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const subjectArea = useSelector(state => state.lookup.courseSubjects)
  const { query } = useSelector(state => state.scheduling.course)
  const [que, setQue] = useState(query?.que || '')

  const filterNullValues = obj => {
    let temp = {}
    Object.keys(obj).forEach(key => {
      obj[key] !== null && obj[key] !== 'all' ? (temp[key] = obj[key]) : null
    })
    return temp
  }

  const applyFilter = async (key, value) => {
    if (value || value === false) {
      dispatch(search({ ...filterNullValues(query), [key]: value, offset: 0 }))
    } else {
      dispatch(search({ ...omit(query, key), offset: 0 }))
    }
  }

  const delayedSearch = useMemo(() => {
    return debounce((que, callback) => callback('name', que), 500)
  }, [dispatch])

  useEffect(() => {
    subjectArea || dispatch(getCourseSubjects())
  }, [])

  if (!(subjectArea, query)) return null

  return (
    <Stack direction="row" spacing={2} sx={{ py: 2 }}>
      <TextField
        size="medium"
        fullWidth
        value={que || query?.que}
        placeholder="Search"
        onChange={event => {
          setQue(event.target.value)
          delayedSearch(event.target.value, applyFilter)
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <CloseIcon
              onClick={() => {
                setQue('')
                applyFilter('name', '')
              }}
              sx={{ '&:hover': { cursor: 'pointer' }, fontSize: 'small' }}
            />
          ),
        }}
      />

      <TextField
        select
        sx={{ width: '23em' }}
        size="medium"
        label={t('Subject Area')}
        placeholder="Subject Area"
        color="primary"
        onChange={event => applyFilter('subjectId', event.target.value !== 'all' ? event.target.value : null)}
        value={query?.subjectId || 'all'}
      >
        <MenuItem value={'all'}>All</MenuItem>
        {subjectArea &&
          subjectArea.map(item => (
            <MenuItem key={item.id} value={item.id}>
              {item.name}
            </MenuItem>
          ))}
      </TextField>

      <TextField
        // onChange={event => applyFilter('enabled', event.target.value)}
        onChange={event => {
          if (event.target.value === 'true') {
            applyFilter('enabled', true)
          } else if (event.target.value === 'false') {
            applyFilter('enabled', false)
          } else {
            applyFilter('enabled', null)
          }
        }}
        select
        sx={{ width: '23em' }}
        size="medium"
        label={t('Status')}
        placeholder="Status"
        color="primary"
        value={query?.enabled === false ? 'false' : query?.enabled ? 'true' : 'all'}
      >
        <MenuItem value={'all'}>{t('All')}</MenuItem>
        <MenuItem value={'true'}>{t('Active')}</MenuItem>
        <MenuItem value={'false'}>{t('Passive')}</MenuItem>
      </TextField>
    </Stack>
  )
}
